export default "__VITE_PUBLIC_ASSET__3822ae99__"